module.exports = __webpack_public_path__ + "static/media/tks.9e0a8823.png";